<template>
  <main class="mb-16 pb-8">
    <div class="max-w-3xl mx-auto px-4 sm:px-6 lg:max-w-7xl lg:px-8">
      <div
        class="rounded-lg overflow-hidden shadow sm:grid sm:grid-cols-3 sm:gap-4"
      >
        <div class="bg-white p-6">
          <!-- This example requires Tailwind CSS v2.0+ -->
          <div
            class="text-center bg-gray-50 border-dashed border-2 border-gray-200 py-8"
          >
            <span class="text-5xl font-extrabold text-gray-600">
              {{ contacts.length }}</span
            >
            <h3 class="text-base font-medium text-gray-900">Contacts</h3>
            <p class="mt-1 text-sm text-gray-500">
              Import and add contacts <br />Assign to multiples tags and
              messages
            </p>
            <div class="mt-6 flex gap-2 justify-center">
              <button
                type="button"
                @click="createContact()"
                class="inline-flex items-center px-4 py-2 shadow-sm text-sm font-medium rounded-md text-white bg-gray-600 hover:bg-gray-800 focus:outline-none"
              >
                <svg
                  class="-ml-1 mr-2 h-5 w-5"
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 20 20"
                  fill="currentColor"
                  aria-hidden="true"
                >
                  <path
                    fill-rule="evenodd"
                    d="M10 3a1 1 0 011 1v5h5a1 1 0 110 2h-5v5a1 1 0 11-2 0v-5H4a1 1 0 110-2h5V4a1 1 0 011-1z"
                    clip-rule="evenodd"
                  />
                </svg>
                New Contact
              </button>

              <button
                @click="redirectContacts"
                type="button"
                class="inline-flex items-center px-4 py-2 shadow-sm text-sm font-medium rounded-md text-gray-800 bg-gray-200 hover:bg-gray-300 focus:outline-none"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  class="-ml-1 mr-1 h-5 w-5"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                  stroke-width="2"
                >
                  <path
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    d="M4 6a2 2 0 012-2h2a2 2 0 012 2v2a2 2 0 01-2 2H6a2 2 0 01-2-2V6zM14 6a2 2 0 012-2h2a2 2 0 012 2v2a2 2 0 01-2 2h-2a2 2 0 01-2-2V6zM4 16a2 2 0 012-2h2a2 2 0 012 2v2a2 2 0 01-2 2H6a2 2 0 01-2-2v-2zM14 16a2 2 0 012-2h2a2 2 0 012 2v2a2 2 0 01-2 2h-2a2 2 0 01-2-2v-2z"
                  />
                </svg>
                Manage
              </button>

              <button
                type="button"
                @click="isOpenImport = true"
                class="inline-flex items-center px-4 py-2 shadow-sm text-sm font-medium rounded-md text-gray-800 bg-gray-200 hover:bg-gray-300 focus:outline-none"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                  stroke-width="2"
                  class="h-5 w-5"
                >
                  <path
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    d="M13.828 10.172a4 4 0 00-5.656 0l-4 4a4 4 0 105.656 5.656l1.102-1.101m-.758-4.899a4 4 0 005.656 0l4-4a4 4 0 00-5.656-5.656l-1.1 1.1"
                  ></path>
                </svg>
              </button>
            </div>
          </div>
        </div>

        <div class="bg-white p-6">
          <!-- This example requires Tailwind CSS v2.0+ -->
          <div
            class="text-center bg-gray-50 border-dashed border-2 border-gray-200 py-8"
          >
            <span class="text-5xl font-extrabold text-gray-600">
              {{ messages.length }}</span
            >
            <h3 class="text-base font-medium text-gray-900">Messages</h3>
            <p class="mt-1 text-sm text-gray-500">
              Create and sent to all Contacts with specified Tags - Deliver
              status
            </p>
            <div class="mt-6 flex gap-2 justify-center">
              <button
                type="button"
                @click="emitCreate"
                class="inline-flex items-center px-4 py-2 shadow-sm text-sm font-medium rounded-md text-white bg-gray-600 hover:bg-gray-800 focus:outline-none"
              >
                <svg
                  class="-ml-1 mr-2 h-5 w-5"
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 20 20"
                  fill="currentColor"
                  aria-hidden="true"
                >
                  <path
                    fill-rule="evenodd"
                    d="M10 3a1 1 0 011 1v5h5a1 1 0 110 2h-5v5a1 1 0 11-2 0v-5H4a1 1 0 110-2h5V4a1 1 0 011-1z"
                    clip-rule="evenodd"
                  />
                </svg>
                New Message
              </button>
              <button
                type="button"
                @click="allMessages"
                class="inline-flex items-center px-4 py-2 shadow-sm text-sm font-medium rounded-md text-gray-800 bg-gray-200 hover:bg-gray-300 focus:outline-none"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  class="-ml-1 mr-1 h-5 w-5"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                  stroke-width="2"
                >
                  <path
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    d="M4 6a2 2 0 012-2h2a2 2 0 012 2v2a2 2 0 01-2 2H6a2 2 0 01-2-2V6zM14 6a2 2 0 012-2h2a2 2 0 012 2v2a2 2 0 01-2 2h-2a2 2 0 01-2-2V6zM4 16a2 2 0 012-2h2a2 2 0 012 2v2a2 2 0 01-2 2H6a2 2 0 01-2-2v-2zM14 16a2 2 0 012-2h2a2 2 0 012 2v2a2 2 0 01-2 2h-2a2 2 0 01-2-2v-2z"
                  />
                </svg>
                Manage
              </button>
            </div>
          </div>
        </div>

        <div class="bg-white p-6">
          <!-- This example requires Tailwind CSS v2.0+ -->
          <div
            class="text-center bg-gray-50 border-dashed border-2 border-gray-200 py-8"
          >
            <span class="text-5xl font-extrabold text-gray-600">
              {{ tags.length }}</span
            >
            <h3 class="text-sm font-medium text-gray-900">Tags</h3>
            <p class="mt-1 text-sm text-gray-500">
              Create - remove and assigned to <br />
              Contacts and Messages
            </p>
            <div class="mt-6">
              <button
                @click="isOpenTag = true"
                type="button"
                class="inline-flex items-center px-4 py-2 shadow-sm text-sm font-medium rounded-md text-white bg-gray-600 hover:bg-gray-800 focus:outline-none"
              >
                <!-- Heroicon name: solid/plus -->
                <svg
                  class="-ml-1 mr-2 h-5 w-5"
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 20 20"
                  fill="currentColor"
                  aria-hidden="true"
                >
                  <path
                    fill-rule="evenodd"
                    d="M10 3a1 1 0 011 1v5h5a1 1 0 110 2h-5v5a1 1 0 11-2 0v-5H4a1 1 0 110-2h5V4a1 1 0 011-1z"
                    clip-rule="evenodd"
                  />
                </svg>
                New Tag
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="px-2 py-4 text-center font-sans">
      <!-- Modal -->
      <!-- This example requires Tailwind CSS v2.0+ -->
      <div v-if="isOpenAllMessages">
        <managemodal
          :messages="messages"
          :tags="tags"
          v-on:event="reactivePage"
        >
        </managemodal>
      </div>

      <!-- Modal -->
      <!-- This example requires Tailwind CSS v2.0+ -->
      <div class="fixed z-10  inset-0 overflow-y-auto" v-if="isOpenTag">
        <div
          class="flex items-end justify-center min-h-screen pt-4 px-4 pb-20 text-center sm:block sm:p-0"
        >
          <div class="fixed inset-0 transition-opacity" aria-hidden="true">
            <div class="absolute inset-0 bg-gray-500 opacity-75"></div>
          </div>

          <!-- This element is to trick the browser into centering the modal contents. -->
          <span
            class="hidden sm:inline-block sm:align-middle sm:h-screen"
            aria-hidden="true"
            >&#8203;</span
          >

          <div
            class="sm:w-5/12 inline-block bg-white rounded-lg text-left overflow-hidden shadow-xl transform transition-all align-middle"
            role="dialog"
            aria-modal="true"
            aria-labelledby="modal-headline"
          >
            <div class="px-4 pt-5 pb-4 sm:p-6 sm:pb-4">
              <v-switch
                v-model="switch1"
                inset
                label="Tag Management"
              ></v-switch>

              <div v-if="switch1" class="mb-4">
                <div class=" text-gray-600">
                  <input
                    v-model="searchtag"
                    type="search"
                    name="serch"
                    placeholder="Search Tag"
                    class="shadow bg-white h-10 w-full px-5 pr-10 rounded-full text-sm focus:outline-none"
                  />
                </div>

                <!-- style="height: 5em; overflow: auto;" -->
                <div class="m-4">
                  <div class="mx-auto grid gap-2 sm:grid-cols-3 m-1">
                    <div v-for="crmTag in filterTags" :key="crmTag.id">
                      <v-tooltip bottom>
                        <template v-slot:activator="{ on, attrs }">
                          <span
                            v-bind="attrs"
                            v-on="on"
                            class="ml-1 inline-flex rounded-full items-center py-0.5 pl-2.5 pr-1 text-sm font-medium bg-gray-100 text-gray-700"
                          >
                            {{ crmTag.name }}
                            <button
                              @click="removeTag(crmTag)"
                              type="button"
                              class="flex-shrink-0 ml-0.5 h-4 w-4 rounded-full inline-flex items-center justify-center text-indigo-400 hover:bg-indigo-200 hover:text-indigo-500 focus:outline-none focus:bg-indigo-500 focus:text-white"
                            >
                              <i class="fas fa-times-circle"></i>
                            </button>
                          </span>
                        </template>
                        <span>
                          <div
                            v-for="tagUser in crmTag.users"
                            :key="tagUser.id"
                          >
                            {{ tagUser.name }}
                          </div>
                        </span>
                      </v-tooltip>
                    </div>
                  </div>
                </div>
              </div>
              <br />

              <div class="mt-4">
                <h3 class=" text-lg leading-6 font-medium text-gray-900">
                  Create Tag to use in Contacts
                </h3>
                <p class="text-sm text-gray-500">
                  Tags are assigned to multiple contacts
                </p>

                <v-form @submit.prevent="saveTag()">
                  <div class="form-group">
                    <label for="name">Tag Name:</label>

                    <div class="mt-1 flex rounded-md shadow-sm">
                      <div
                        class="relative flex items-stretch flex-grow focus-within:z-10"
                      >
                        <input
                          @change="validateName"
                          v-model="tag.name"
                          type="text"
                          class="form-control p-4 focus:ring-indigo-500 focus:border-indigo-500 block w-full rounded-none rounded-l-md  sm:text-sm border-gray-300"
                          placeholder="What is the name of the Tag"
                        />
                      </div>
                      <a
                        class="-ml-px relative inline-flex items-center space-x-2 px-4 py-2 border border-gray-300 text-sm font-medium rounded-r-md text-gray-700 bg-gray-50 hover:bg-gray-100 focus:outline-none focus:ring-1 focus:ring-indigo-500 focus:border-indigo-500"
                      >
                        <span>Validate</span>
                      </a>
                    </div>

                    <span v-if="showError" class="text-xs text-red-600"
                      >* Tag already exists</span
                    >
                    <span v-else-if="showSuccess" class="text-xs text-green-600"
                      >* Tag available</span
                    >
                  </div>

                  <div
                    class="bg-gray-50 px-4 py-3 sm:px-6 sm:flex sm:flex-row-reverse"
                  >
                    <!-- tag.name.length <= 3 ||  -->
                    <button
                      :disabled="buttonDisabled || showError === true"
                      type="submit"
                      class="disabled:opacity-50  mt-3 w-full inline-flex justify-center rounded-md border border-gray-300 shadow-sm px-4 py-2 bg-primary text-white font-medium hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500 sm:mt-0 sm:ml-3 sm:w-auto sm:text-sm"
                    >
                      Save
                    </button>
                    <button
                      @click="clearTagSelected()"
                      type="button"
                      class="mt-3 w-full inline-flex justify-center rounded-md border border-gray-300 shadow-sm px-4 py-2 bg-white text-base font-medium text-gray-700 hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500 sm:mt-0 sm:ml-3 sm:w-auto sm:text-sm"
                    >
                      Cancel
                    </button>
                  </div>
                </v-form>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Modal -->
      <!-- This example requires Tailwind CSS v2.0+ -->
      <div class="fixed z-10  inset-0 overflow-y-auto" v-if="isOpenImport">
        <div
          class="flex items-end justify-center min-h-screen pt-4 px-4 pb-20 text-center sm:block sm:p-0"
        >
          <div class="fixed inset-0 transition-opacity" aria-hidden="true">
            <div class="absolute inset-0 bg-gray-500 opacity-75"></div>
          </div>

          <!-- This element is to trick the browser into centering the modal contents. -->
          <span
            class="hidden sm:inline-block sm:align-middle sm:h-screen"
            aria-hidden="true"
            >&#8203;</span
          >

          <div
            class="sm:w-5/12 inline-block bg-white rounded-lg text-left overflow-hidden shadow-xl transform transition-all align-middle"
            role="dialog"
            aria-modal="true"
            aria-labelledby="modal-headline"
          >
            <div class="px-4 pt-5 pb-4 sm:p-6 sm:pb-4">
              <v-switch
                @click="importContacts()"
                v-model="switch1"
                inset
                label="Import contacts from Homemanager"
              ></v-switch>

              <div v-if="switch1" class="mb-4">
                <div v-if="contactsImportedModal">
                  <importedmodal
                    :imported="imported"
                    v-on:event="importadModalFalse"
                  >
                  </importedmodal>
                </div>
              </div>

              <div v-else>
                <div class="sm:border-t sm:border-gray-200 sm:pt-5">
                  <div class="mt-1 sm:mt-0">
                    <div
                      class="grid grid-cols-1 gap-y-4 sm:gap-y-0 sm:grid-cols-2"
                    >
                      <div
                        class="flex justify-center px-6 pt-5 pb-6 border-2 border-gray-300 border-dashed rounded-md"
                      >
                        <div class="space-y-1 text-center">
                          <svg
                            class="mx-auto h-12 w-12 text-gray-400"
                            stroke="currentColor"
                            fill="none"
                            viewBox="0 0 48 48"
                            aria-hidden="true"
                          >
                            <path
                              d="M28 8H12a4 4 0 00-4 4v20m32-12v8m0 0v8a4 4 0 01-4 4H12a4 4 0 01-4-4v-4m32-4l-3.172-3.172a4 4 0 00-5.656 0L28 28M8 32l9.172-9.172a4 4 0 015.656 0L28 28m0 0l4 4m4-24h8m-4-4v8m-12 4h.02"
                              stroke-width="2"
                              stroke-linecap="round"
                              stroke-linejoin="round"
                            />
                          </svg>
                          <div
                            class="text-sm text-gray-600 text-center justify-center"
                          >
                            <label
                              for="file-upload"
                              class="relative cursor-pointer"
                            >
                              <span
                                class="animate-pulse inline-flex items-center px-3 py-0.5 rounded-full text-sm font-medium bg-blue-600 text-white"
                                >Upload a csv file</span
                              >
                              <input
                                @change="uploadFiles"
                                id="file-upload"
                                accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
                                name="file-upload"
                                type="file"
                                class="sr-only"
                              />
                            </label>
                            <p class="flex-col text-xs text-gray-500">
                              XLSX up to 10MB
                            </p>
                          </div>
                        </div>
                      </div>

                      <div class="px-4">
                        <div
                          v-if="csvFile.length > 0"
                          class="rounded-md bg-blue-50 p-2"
                        >
                          <span class="text-base font-bold text-gray-900"
                            >Settings
                            <div class="flex ml-1">
                              <div class="flex-shrink-0">
                                <!-- Heroicon name: solid/information-circle -->
                                <svg
                                  class="h-5 w-5 text-blue-400"
                                  xmlns="http://www.w3.org/2000/svg"
                                  viewBox="0 0 20 20"
                                  fill="currentColor"
                                  aria-hidden="true"
                                >
                                  <path
                                    fill-rule="evenodd"
                                    d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7-4a1 1 0 11-2 0 1 1 0 012 0zM9 9a1 1 0 000 2v3a1 1 0 001 1h1a1 1 0 100-2v-3a1 1 0 00-1-1H9z"
                                    clip-rule="evenodd"
                                  />
                                </svg>
                              </div>
                              <div
                                class="ml-1 flex-1 md:flex md:justify-between"
                              >
                                <p class="text-sm text-blue-700">
                                  {{ csvFile[0].name }}
                                </p>
                              </div>
                            </div>
                          </span>

                          <v-radio-group v-model="selectedRadio" mandatory row>
                            <v-radio label="Change Tag"></v-radio>
                            <v-radio label="Assign Tag"></v-radio>
                          </v-radio-group>
                        </div>

                        <multiselect
                          class="w-full"
                          :multiple="true"
                          v-model="tagsSelected"
                          :options="tags"
                          :close-on-select="true"
                          :clear-on-select="true"
                          :preserve-search="true"
                          placeholder="Search tag"
                          label="name"
                          track-by="id"
                          :preselect-first="false"
                        >
                        </multiselect>

                        <v-btn
                          :disabled="
                            selectedRadio || tagsSelected ? false : true
                          "
                          class="ma-1 disabled:opacity-50"
                          @click="importCsv()"
                          :loading="loading"
                          color="success"
                          plain
                        >
                          Save
                        </v-btn>

                        <button
                          type="button"
                          @click="csvFile = []"
                          class="cursor-pointer ml-0.5 inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-red-100 text-red-800"
                        >
                          Close
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div
              class="bg-gray-50 px-4 py-3 sm:px-6 sm:flex sm:flex-row-reverse"
            >
              <button
                @click="isOpenImport = false"
                type="button"
                class="mt-3 w-full inline-flex justify-center rounded-md border border-gray-300 shadow-sm px-4 py-2 bg-white text-base font-medium text-gray-700 hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500 sm:mt-0 sm:ml-3 sm:w-auto sm:text-sm"
              >
                Close
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </main>
</template>
<script
  src="https://code.jquery.com/jquery-3.5.1.slim.min.js"
  integrity="sha384-DfXdz2htPH0lsSSs5nCTpuj/zy4C+OGpamoFVy38MVBnE+IbbVYUew+OrCXaRkfj"
  crossorigin="anonymous"
></script>
<script>
import Multiselect from "vue-multiselect";
import Importedmodal from "../Modals/ImportedModal";
import Managemodal from "../Modals/ManageMessageModal";
import Swal from "sweetalert2";
export default {
  components: {
    Importedmodal,
    Multiselect,
    Managemodal
  },
  props: ["tags", "messages", "contacts"],
  data() {
    return {
      csvFile: [],
      contactsImportedModal: false,
      imported: [],
      tagsSelected: [],
      isOpenAllMessages: false,
      isOpenTag: false,
      searchtag: "",
      switch1: false,
      tag: {
        name: ""
      },
      showError: false,
      showSuccess: false,
      buttonDisabled: true,
      isOpenImport: false,
      csvUrlFile: "",
      loading: false,
      selectedRadio: null
    };
  },

  computed: {
    filterTags() {
      if (this.searchtag == "") {
        return this.tags;
      } else {
        return this.tags.filter(user => {
          return user.name.toLowerCase().includes(this.searchtag.toLowerCase());
        });
      }
    }
  },

  methods: {
    redirectContacts() {
      this.$router.push({ name: "CrmContacts" });
    },
    createContact() {
      this.$emit("displayContactModal");
    },

    emitCreate() {
      this.$emit("displayMessageModal");
    },

    //methods for import csv
    importCsv() {
      this.loading = true;
      var config = {
        headers: { "Content-Type": "multipart/form-data" }
      };

      let fileCsv = new FormData();

      $.each(this.tagsSelected, function(key, value) {
        fileCsv.append(`tagIds[${key}]`, value.id);
      });
      fileCsv.append("selectedRadio", this.selectedRadio);
      $.each(this.csvFile, function(key, csv) {
        fileCsv.append(`csv[${key}]`, csv);
      });

      window.axios.post("/api/import/csv", fileCsv, config).then(() => {
        Swal.fire({
          position: "top-end",
          icon: "success",
          title: "Succesfully imported",
          showConfirmButton: false,
          timer: 1500
        });
        this.isOpenImport = false;
        this.$emit("refreshContacts");
        this.loading = false;
      });
    },

    importContacts() {
      window.axios.get("/api/getContacts").then(response => {
        this.imported = response.data;
        this.contactsImportedModal = true;
      });
    },

    uploadFiles(e) {
      this.csvFile = e.target.files || e.dataTransfer.files;

      const file = e.target.files[0];
      this.csvUrlFile = URL.createObjectURL(file);
    },

    importadModalFalse() {
      this.contactsImportedModal = false;
      this.imported = [];
    },

    allMessages() {
      this.isOpenAllMessages = true;
    },

    reactivePage() {
      this.isOpenAllMessages = false;
    },

    clearTagSelected() {
      this.isOpenTag = false;
      this.tag.name = "";
      this.showSuccess = false;
    },

    validateName() {
      window.axios.post("/api/validateTag", this.tag).then(res => {
        if (res.data === "error") {
          this.showError = true;
          this.showSuccess = false;
        } else {
          this.showError = false;
          this.showSuccess = true;
          this.buttonDisabled = false;
        }
      });
    },

    saveTag() {
      window.axios.post("/api/crmTag", this.tag).then(() => {
        this.showError = false;
        this.showSuccess = false;
        this.tag = {};
        this.isOpenTag = false;
        Swal.fire({
          position: "top-end",
          icon: "success",
          title: "Tag succesfully created",
          showConfirmButton: false,
          timer: 1500
        });

        this.$emit("refreshTags");
      });
    },

    removeTag(tag) {
      window.axios.post("/api/removeTag/" + tag.id).then(() => {
        Swal.fire({
          position: "top-end",
          icon: "success",
          title: "Tag succesfully removed",
          showConfirmButton: false,
          timer: 1500
        });

        this.$emit("refreshTags");
      });
    }
  }
};
</script>
